var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Slider',_vm._b({model:{value:(_vm.innerVal),callback:function ($$v) {_vm.innerVal=$$v},expression:"innerVal"}},'Slider',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }